import Tooltip from "./Tooltip"

export default class SimpleTooltip extends Tooltip {
    constructor({
        text = '',
        extraClass = '',
    } = {}) {
        super()
        this.text = text
        this.extraClass = extraClass
    }

    templateHtml() {
        return "<div class='simpleTooltip'><%-text%></div>"
    }

    afterRender() {
        super.afterRender()
        if (this.extraClass)
            this.$el.addClass(this.extraClass)
    }

    setText(text) {
        this.$el.text(text)
    }

    setHtml(html) {
        this.$el.html(html)
    }
}




// WEBPACK FOOTER //
// ./web/js/SimpleTooltip.js